module.exports = __webpack_public_path__ + "static/media/yings.8ee312bc.png";